import { Box, Button, styled } from "@mui/material";
import { X } from "@phosphor-icons/react";
import React, { useEffect, useMemo } from "react";
import { useData } from "../../hooks/StateContext";
import { listAllFlavour, listAllWeight } from "../../utilities";

const QuantityButton = styled(Button)(() => ({
  border: "1px solid var(--neutral-400)",
  borderRadius: "8px",
  padding: "12px 16px",
  fontWeight: 500,
  fontSize: "16px",
  color: "var(--neutral-800)",
  height: "44px",
  lineHeight: "120%",
  backgroundColor: "rgba(247, 247, 247, 0.5)",
  "&:hover": {
    backgroundColor: "#FFFFFF",
    transform: "scale(1.01, 1.01)",
    transformOrigin: "center center",
    transition: "0.1s ease-in",
    fontWeight: 600,
  },
}));

function Filter({ filterValues, setFilterValues, data }) {
  const {
    appData: { listing },
    setAppData,
  } = useData();

  /* ---------------------------------------
     DERIVE DATA FROM API (NO STALE STATE)
  ---------------------------------------- */
  const weightList = useMemo(() => {
    return data ? listAllWeight(data) : [];
  }, [data]);

  const flavourList = useMemo(() => {
    return data ? listAllFlavour(data) : [];
  }, [data]);

  useEffect(() => {
    setAppData((prev) => ({
      ...prev,
      listing: {
        weightList: weightList,
      },
    }));
  }, [weightList, setAppData]);

  const handleWeightRadioChange = (value) => {
    setFilterValues((prev) => {
      if (prev?.weight?.includes(value)) {
        const updatedWeight = prev.weight.filter((item) => item !== value);
        return { ...prev, weight: updatedWeight.length ? updatedWeight : null };
      }
      return {
        ...prev,
        weight: prev?.weight ? [...prev.weight, value] : [value],
      };
    });
  };

  const handleReset = () => {
    setFilterValues({ weight: null, flavour: null });
    setAppData((prev) => ({
      ...prev,
      listing: {
        weightList: [],
      },
    }));
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", columnGap: 2, rowGap: 2 }}>
      {listing?.weightList?.map((weight, index) => {
        const isSelected = filterValues?.weight?.includes(weight.weight_id);

        return (
          <QuantityButton
            key={index}
            onClick={() => handleWeightRadioChange(weight.weight_id)}
            variant="outlined"
            endIcon={<X size={16} weight="bold" />}
            sx={{
              fontWeight: isSelected ? 600 : 500,
              border: isSelected
                ? "1px solid var(--primary-red-base)"
                : "1px solid var(--neutral-400)",
              color: isSelected
                ? "var(--neutral-black)"
                : "var(--neutral-800)",
              backgroundColor: isSelected
                ? "rgba(255, 212, 213, 0.48)"
                : "rgba(247, 247, 247, 0.5)",
            }}
          >
            {`${weight.weight_name} ${weight.unit_name}`}
          </QuantityButton>
        );
      })}
    </Box>
  );
}

export default Filter;
